<template>
  <atoms-popover-v2
    class="flex items-center"
    position="top"
    append-popover-class="exact-w-[18rem]"
    force-position-x="left"
    force-tip-position-x="left"
  >
    <div
      class="font-bold inline-flex items-center py-1 rounded-full border border-cyan-600 text-xs leading-3 cursor-pointer gap-1"
      :class="{
        'pl-1 pr-2': !collapse,
        'px-1': collapse
      }"
    >
      <IconsCheckedBox
        class="w-4 h-4"
        fill="#01BAEF"
        type="circle"
      />

      <template v-if="!collapse">
        Fact Checked
      </template>
    </div>

    <template #content>
      <p class="uppercase">
        This content has been checked by a Compare Club Expert. This check gives you the confidence that everything you read here is the highest quality and trustworthy content.
      </p>
    </template>
  </atoms-popover-v2>
</template>

<script setup>
defineOptions({
  name: 'AtomsFactChecked'
})

defineProps({
  collapse: {
    type: Boolean,
    default: false
  }
})
</script>
